<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="tokutei">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>特定商取引法の表示</h2>
            <ul class="mokuji">
              <li>目次</li>
              <li><a @click="scrollToAnchorPoint('corp_domans')">ドゥーマンズ株式会社</a></li>
              <li><a @click="scrollToAnchorPoint('corp_funiturmaker')">ファニチャーメーカー株式会社</a></li>
              <li><a @click="scrollToAnchorPoint('corp_miura')">株式会社みうら</a></li>
              <li><a @click="scrollToAnchorPoint('corp_candeal')">株式会社キャンディルテクト</a></li>
              <li><a @click="scrollToAnchorPoint('corp_axis')">アクシス株式会社</a></li>
              <li><a @click="scrollToAnchorPoint('corp_tecma')">株式会社テクマ</a></li>
            </ul>
            <div class="corp_table" ref="corp_domans">
              <div>ドゥーマンズ株式会社</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>ドゥーマンズ株式会社</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>二宮 健一</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>東京都渋谷区代々木 3-28-6 いちご西参道ビル １階</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>03-5354-7671</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>info@domans.co.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="https://www.domans.co.jp/" target="_blank" rel="noopener noreferrer">https://www.domans.co.jp/</a></div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    ・配送料<br>
                    ・（ご選択された場合）組立設置等のサービス料
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    ※ 入金確認後の製作となります。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div class="corp_table" ref="corp_funiturmaker">
              <div>ファニチャーメーカー株式会社</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>ファニチャーメーカー株式会社 FurnitureMaker Inc.</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>大瀧 夏彦</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>東京都渋谷区代々木 3-28-6 いちご西参道ビル １階</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>03-6300-9085</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>mmstyle@furnituremaker.co.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="https://furnituremaker.co.jp/" target="_blank" rel="noopener noreferrer">https://furnituremaker.co.jp/</a></div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    ・配送料<br>
                    ・（ご選択された場合）組立設置等のサービス料
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    ※ 入金確認後の製作となります。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください。
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div class="corp_table" ref="corp_miura">
              <div>株式会社みうら</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>株式会社みうら</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>三浦 和久</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>山口県周南市野村３丁目24-1</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>0834-63-8811</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>miura@w-miura.co.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="http://miura-wood.com" target="_blank" rel="noopener noreferrer">http://miura-wood.com</a></div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    ・配送料<br>
                    ・（ご選択された場合）組立設置等のサービス料
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    ※ 入金確認後の製作となります。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div class="corp_table" ref="corp_axis">
              <div>アクシス株式会社</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>アクシス株式会社</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>彦坂 充宏</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>大阪市西区南堀江2-13-26</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>06-6536-2030</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>spc@ce-fit.com</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div>
                    <div><a href="https://olis.group/corp-axis/" target="_blank" rel="noopener noreferrer">https://olis.group/corp-axis/</a></div>
                  </div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    無し（配送料は商品代金に含まれます）
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    ※ 入金確認後の製作となります。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div class="corp_table" ref="corp_tecma">
              <div>株式会社テクマ</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>株式会社テクマ</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>彦坂 充宏</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>兵庫県丹波篠山市吹上１</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>079-552-5498</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>spc@ce-fit.com</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div>
                    <div><a href="https://olis.group/corp-tecma/" target="_blank" rel="noopener noreferrer">https://olis.group/corp-tecma/</a></div>
                  </div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    無し（配送料は商品代金に含まれます）
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    ※ 入金確認後の製作となります。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div class="corp_table" ref="corp_candeal">
              <div>株式会社キャンディルテクト</div>
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>株式会社キャンディルテクト</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>三浦 翔</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>東京都江東区常盤1-2-5</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>03-5625-4587</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>te_hp@candeal.co.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="https://candeal-tect.co.jp" target="_blank" rel="noopener noreferrer">https://candeal-tect.co.jp</a></div>
                </li>
                <li>
                  <div>サービスの販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>サービス以外の必要料金</div>
                  <div>
                    組立設置オプションには以下の費用が発生します。<br>
                    ・組立技術料：組立作業費および副資材、簡易養生材など。<br>
                    ・諸経費：交通費、燃料代など。
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・銀行振込、またはクレジットカード決済<br>
                    ・掛け払い（審査を経た特定の法人のみ）
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 銀行振込 】<br>
                    ご注文後、7日以内にお振込みをお願いいたします。<br>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                    【 掛け払い 】<br>
                    メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。
                  </div>
                </li>
                <li>
                  <div>サービスの開始・完成時期</div>
                  <div>
                    工事の開始時期及び完成時期は、別途お客様と合意した時期といたします。<br>
                    ※地域（離島、遠隔地等）または時期（年末年始・夏季休業等）によっては通常より日数をいただく場合がございます。
                  </div>
                </li>
                <li>
                  <div>ご注文のキャンセル</div>
                  <div>
                    組立設置サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできません。<br>
                    詳細は利用規約第１１条をご覧ください。
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcTokukei',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'toukei', key: 'dcTokutei', title: '特定商取引法の表示', route: 'DcTokutei'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    scrollToAnchorPoint: function (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcTokutei.vue